import(/* webpackMode: "eager" */ "/app/app/[lang]/blogs/eats/page.tsx");
